import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  Table,
  Pagination,
  Modal,
  Button,
} from "react-bootstrap";
import { GetRiderlocationPost, getallrider, getallriderAkira, GetAkiraRiderlocationPost } from "../../../Listfunction";
// react component that creates a switch button that changes from on to off mode
import LoadingSpinner from "views/Components/loadingSpinner";
import Datetime from "react-datetime";
import NotificationSystem from "react-notification-system";
import Card from "components/Card/Card.jsx";
import { style } from "../../../variables/Variables";
import Select from "react-select";
import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react";
import moment from "moment";

export class rider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      from_date: "",
      to_date: "",
      rider_details: [],
      selected_rider: null,
      selected_riderError: null,
      loading: false,
      noRecordFound: true,
      _notificationSystem: null,
      rider_data: [],
      locationdetails: [],
      bounds_data: null,
      finallat: parseFloat(0),
      finallng: parseFloat(0),
      locationmodal: false,
      paginationData: [],
      nextpage: "",
      prevpage: "",
      currentPage: 1,
      nextdisabled: "1",
      prevdisabled: "1",
      page: 1,
    };
    this.handlesearch = this.handlesearch.bind(this);
    this.resetSearch = this.resetSearch.bind(this);
  }

  handlefromdate = (date) => {
    this.setState({ from_date: date });
  };

  handletodate = (date) => {
    this.setState({ to_date: date });
  };

  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 5,
    });
  }

  openlocation(lati, long) {
    this.setState({ locationmodal: true });

    var points_data = [{ lat: parseFloat(lati), lng: parseFloat(long) }];
    this.setState({ finallat: parseFloat(lati), finallng: parseFloat(long) });

    var bounds = new this.props.google.maps.LatLngBounds();
    for (var i = 0; i < points_data.length; i++) {
      console.log("hi", points_data[i]);
      bounds.extend(points_data[i]);
    }
    console.log(bounds, "bonds");
    this.setState({ bounds_data: bounds });
  }

  closelocationmodal() {
    this.setState({ locationmodal: false, bounds_data: null });
  }

  componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );

    let role = 5;
    // getallrider("", role, obj)
    //   .then((res) => {
    //     const data = res.data;
    //     var array1 = this.state.rider_details;
    //     var array2 = array1.concat(data);
    //     console.log(array2)

    //     this.setState({
    //       rider_details: array2,
    //     });

    //     let riderItems = [];
    //     this.state.rider_details.map((x, i) => {
    //       riderItems.push({ value: x.id, label: x.userName });
    //     });
    //     this.setState({
    //       rider_data: riderItems,
    //     });
    //   })
    //   .catch(() => {
    //     this.handleNetworkError("bl");
    //   });

      getallriderAkira("", role, obj)
      .then((res) => {
        const data = res;
        var array1 = this.state.rider_details;
        var array2 = array1.concat(data);

        this.setState({
          rider_details: array2,
        });

        let riderItems = [];
        this.state.rider_details.map((x, i) => {
          riderItems.push({ value: x.id, label: x.userName });
        });
        this.setState({
          rider_data: riderItems,
        });
      })
      .catch(() => {
        this.handleNetworkError("bl");
      });
  }

  paginationinfo(url) {
    this.setState({ page: url });
    this.handlesearch();
  }

  handlesearch() {
    this.setState({ noRecordFound: false });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ selected_riderError: null });
    var error = false;

    if (this.state.selected_rider == null) {
      error = true;
      this.setState({
        selected_riderError: (
          <small className="text-danger">Please Select Rider</small>
        ),
      });
    } else {
      this.setState({ selected_riderError: null });
    }

    if (!error) {
      this.setState({ loading: true }, () => {
        var from_date = "";
        var to_date = "";

        if (this.state.from_date != "" && this.state.from_date != null) {
          from_date = moment(this.state.from_date).format("YYYY-MM-DD HH:mm");
          if (from_date == "Invalid date") {
            from_date = "";
          }
        }

        if (this.state.to_date != "" && this.state.to_date != null) {
          to_date = moment(this.state.to_date).format("YYYY-MM-DD HH:mm");
          if (to_date == "Invalid date") {
            to_date = "";
          }
        }

      //   GetRiderlocationPost(
      //     this.state.selected_rider.value,
      //     this.state.page,
      //     from_date,
      //     to_date,
      //     obj
      //   ).then((res) => {
      //     var data = res.data;
      //     if (data.data.length == 0) {
      //       this.setState({ noRecordFound: true });
      //     }
      //     var $no_pages = [];
      //     let serach_string = "";
      //     for (var i = 1; i <= data.last_page; i++) {
      //       if (serach_string == "") {
      //         $no_pages.push(i);
      //       } else {
      //         $no_pages.push(i);
      //       }
      //     }

      //     if (data.current_page == data.last_page) {
      //       this.setState({ prevdisabled: null });
      //       this.setState({ nextdisabled: "1" });
      //     } else if (data.current_page == 1) {
      //       this.setState({ nextdisabled: null });
      //       this.setState({ prevdisabled: "1" });
      //     } else {
      //       this.setState({ nextdisabled: null });
      //       this.setState({ prevdisabled: null });
      //     }
      //     if (data.last_page == 1) {
      //       this.setState({ nextdisabled: 1 });
      //       this.setState({ prevdisabled: 1 });
      //     }
      //     if (data.length == 0) {
      //       $no_pages = [];
      //       this.setState({ nextdisabled: 1 });
      //       this.setState({ prevdisabled: 1 });
      //     }
      //     this.setState({ currentPage: data.current_page });
      //     if (data.next_page_url != null) {
      //       if (serach_string == "") {
      //         this.setState({
      //           nextpage: data.next_page_url.substring(
      //             data.next_page_url.indexOf("=") + 1
      //           ),
      //         });
      //       } else {
      //         this.setState({
      //           nextpage: data.next_page_url.substring(
      //             data.next_page_url.indexOf("=") + 1
      //           ),
      //         });
      //       }
      //     } else {
      //       this.setState({ nextpage: "#" });
      //     }
      //     if (data.prev_page_url != null) {
      //       if (serach_string == "") {
      //         this.setState({
      //           prevpage: data.prev_page_url.substring(
      //             data.prev_page_url.indexOf("?page=") + 1
      //           ),
      //         });
      //       } else {
      //         this.setState({
      //           prevpage: data.prev_page_url.substring(
      //             data.prev_page_url.indexOf("?page=") + 1
      //           ),
      //         });
      //       }
      //     } else {
      //       this.setState({ prevpage: "#" });
      //     }

      //     this.setState({
      //       locationdetails: res.data.data,
      //       paginationData: $no_pages,
      //       loading: false,
      //     });
      //   });
      // });
      GetAkiraRiderlocationPost(
          this.state.selected_rider.value,
          this.state.page,
          from_date,
          to_date,
          obj
        ).then((res) => {
          var data = res.data;
          if (data.length == 0) {
            this.setState({ noRecordFound: true });
          }
          var $no_pages = [];
          let serach_string = "";
          for (var i = 1; i <= data.last_page; i++) {
            if (serach_string == "") {
              $no_pages.push(i);
            } else {
              $no_pages.push(i);
            }
          }

          if (data.current_page == data.last_page) {
            this.setState({ prevdisabled: null });
            this.setState({ nextdisabled: "1" });
          } else if (data.current_page == 1) {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: "1" });
          } else {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: null });
          }
          if (data.last_page == 1) {
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          if (data.length == 0) {
            $no_pages = [];
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          this.setState({ currentPage: data.current_page });
          if (data.next_page_url != null) {
            if (serach_string == "") {
              this.setState({
                nextpage: data.next_page_url.substring(
                  data.next_page_url.indexOf("=") + 1
                ),
              });
            } else {
              this.setState({
                nextpage: data.next_page_url.substring(
                  data.next_page_url.indexOf("=") + 1
                ),
              });
            }
          } else {
            this.setState({ nextpage: "#" });
          }
          if (data.prev_page_url != null) {
            if (serach_string == "") {
              this.setState({
                prevpage: data.prev_page_url.substring(
                  data.prev_page_url.indexOf("?page=") + 1
                ),
              });
            } else {
              this.setState({
                prevpage: data.prev_page_url.substring(
                  data.prev_page_url.indexOf("?page=") + 1
                ),
              });
            }
          } else {
            this.setState({ prevpage: "#" });
          }

          this.setState({
            locationdetails: res.data,
            paginationData: $no_pages,
            loading: false,
          });
        });
      });
    }
  }

  resetSearch() {
    this.setState({
      from_date: "",
      to_date: "",
      noRecordFound: true,
      locationdetails: [],
      selected_rider: "",
    });
  }

  render() {
    var c = 1;
    return (
      <div className="main-content">
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col md={12}>
              <Card
                content={
                  <Row>
                    <Col className="consultation_filter_container">
                      <Row>
                        <Col md={3}>
                          <Select
                            className="react-select primary"
                            classNamePrefix="react-select"
                            placeholder="Rider"
                            name="selected_rider"
                            value={this.state.selected_rider}
                            onChange={(value) =>
                              this.setState({
                                selected_rider: value,
                                selected_riderError:''
                              })
                            }
                            options={this.state.rider_data}
                          />
                          {this.state.selected_riderError}
                        </Col>
                        <Col md={3}>
                          <Datetime
                            className="filter_FormTodate"
                            timeFormat="HH:mm"
                            dateFormat="DD/MM/YYYY"
                            inputProps={{ placeholder: "From Date" }}
                            closeOnSelect={true}
                            value={this.state.from_date}
                            onChange={this.handlefromdate}
                          />
                        </Col>
                        <Col md={3}>
                          <Datetime
                            className="filter_FormTodate"
                            timeFormat="HH:mm"
                            dateFormat="DD/MM/YYYY"
                            inputProps={{ placeholder: "To Date" }}
                            closeOnSelect={true}
                            value={this.state.to_date}
                            onChange={this.handletodate}
                          />
                        </Col>
                        <Col md={3}>
                          <Button
                            bsStyle="info"
                            fill
                            onClick={this.handlesearch}
                          >
                            Search
                          </Button>
                          &nbsp;&nbsp;
                          <Button
                            class="btn-color"
                            fill
                            onClick={this.resetSearch.bind(this)}
                          >
                            Reset
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                    <Col md={12}>
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>Rider Name </th>
                            <th>Latitude</th>
                            <th>Longitude</th>
                            <th>Date Time</th>
                            <th>location</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.loading ? (
                            <tr>
                              <td colspan="6">
                                <LoadingSpinner />
                              </td>
                            </tr>
                          ) : this.state.noRecordFound ? (
                            <tr>
                              <td colspan="6">
                                <center>No record found</center>
                              </td>
                            </tr>
                          ) : (
                            <>
                              {this.state.locationdetails.map((s) => (
                                <tr>
                                  <td>
                                    {this.state.rider_details.map((r) => (
                                      <>{r.id == s.userId ? r.userName : ""}</>
                                    ))}
                                  </td>
                                  <td>{s.latitude}</td>
                                  <td>{s.longitude}</td>
                                  <td>{moment(s.locatedTime).format("YYYY-MM-DD h:mm")}</td>
                                  <td>
                                    <i
                                      className="fa fa-map-marker"
                                      onClick={this.openlocation.bind(
                                        this,
                                        s.latitude,
                                        s.longitude
                                      )}
                                    ></i>
                                  </td>
                                </tr>
                              ))}
                            </>
                          )}
                        </tbody>
                      </Table>
                      {this.state.loading ? (
                        ""
                      ) : this.state.noRecordFound ? (
                        ""
                      ) : (
                        <div style={{ textAlign: "center" }}>
                          <Pagination>
                            <Pagination.First
                              onClick={this.paginationinfo.bind(
                                this,
                                this.state.prevpage
                              )}
                              disabled={this.state.prevdisabled}
                            />
                            {this.state.paginationData.map((url) => (
                              <Pagination.Item
                                active={
                                  this.state.currentPage == c ? "1" : null
                                }
                                onClick={this.paginationinfo.bind(this, url)}
                              >
                                {c++}
                              </Pagination.Item>
                            ))}
                            <Pagination.Last
                              onClick={this.paginationinfo.bind(
                                this,
                                this.state.nextpage
                              )}
                              disabled={this.state.nextdisabled}
                            />
                          </Pagination>
                        </div>
                      )}

                      <Modal
                        show={this.state.locationmodal}
                        onHide={() => this.setState({ locationmodal: true })}
                      >
                        <Modal.Header>
                          <Modal.Title>Rider Location</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <Row>
                            <Col md={15}>
                              <div style={{ height: "260px" }}>
                                {this.state.locationdetails.length != 0 ? (
                                  <Map
                                    className="form-control"
                                    style={{ width: "100%" }}
                                    initialCenter={{
                                      lat: this.state.finallat,
                                      lng: this.state.finallng,
                                    }}
                                    bounds={this.state.bounds_data}
                                    google={this.props.google}
                                  >
                                    {this.state.finallat != 0 &&
                                    this.state.finallng != 0 ? (
                                      <Marker
                                        position={{
                                          lat: this.state.finallat,
                                          lng: this.state.finallng,
                                        }}
                                        name={"Sri Lanka"}
                                      />
                                    ) : (
                                      <Marker
                                        position={{ lat: "", lng: "" }}
                                        name={"Sri Lanka"}
                                      />
                                    )}

                                    <InfoWindow
                                      onClose={this.onInfoWindowClose}
                                    >
                                      <div>
                                        {/* <h1>{this.state.selectedPlace.name}</h1> */}
                                      </div>
                                    </InfoWindow>
                                  </Map>
                                ) : (
                                  <h4>Rider Location Not Found </h4>
                                )}
                              </div>
                            </Col>
                          </Row>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            bsStyle="danger"
                            onClick={this.closelocationmodal.bind(this)}
                          >
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </Col>
                  </Row>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyDYcP1T9HnFmllB0f_lMixg9EwNdkYCenE",
})(rider);
